var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMachineryLoan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3500 2000",
    style: {
      enableBackground: "new 0 0 3500 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3500,
    height: 2000
  })), /*#__PURE__*/React.createElement("g", {
    id: "window"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 802.238,
    y: 352.62,
    style: {
      fill: "#E3FAFA"
    },
    width: 702.643,
    height: 663.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1945.669,
    y: 411.756,
    style: {
      fill: "#E3FAFA"
    },
    width: 632.815,
    height: 597.238
  }))), /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3EEFA"
    },
    d: "M3188.577,1341.793l-16.947,2.304c-2.448-18.459-8.678-36.024-17.915-51.822l14.708-8.647 c-10.228-17.396-23.839-32.855-40.185-45.271l-10.362,13.595c-14.267-10.871-30.883-19.136-49.342-23.926l4.3-16.574 c-14.166-3.676-28.41-5.286-42.378-4.999v80.917c7.255-0.292,14.673,0.452,22.065,2.37 c40.494,10.506,64.764,51.781,54.273,92.212c-9.125,35.17-41.464,58.086-76.339,56.623v80.845 c8.148,0.153,16.223-0.332,24.16-1.445l-2.303-16.948c18.458-2.447,36.085-8.662,51.883-17.898l8.648,14.708 c17.395-10.228,32.854-23.841,45.27-40.185l-0.063-0.016l-3.906-3.024l-9.625-7.322c10.872-14.267,19.136-30.884,23.925-49.342 l16.575,4.301C3190.297,1381.907,3191.328,1361.402,3188.577,1341.793z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3EEFA"
    },
    d: "M3142.993,1013.713c-6.408,9.765-10.591,20.344-12.671,31.138l9.332,1.812 c-1.976,10.173-1.85,20.56,0.192,30.524l-9.284,1.928c2.28,10.981,6.656,21.528,13.044,30.98l1.761-1.173l6.118-4.134 c5.57,8.268,12.872,15.604,21.733,21.418l-5.221,7.957c9.765,6.408,20.344,10.59,31.158,12.642l1.812-9.332 c10.153,2.006,20.54,1.88,30.504-0.163l1.927,9.285c10.981-2.28,21.548-6.686,31-13.074l-0.03-0.02l-1.516-2.289l-3.76-5.572 c8.268-5.569,15.584-12.842,21.398-21.703l7.957,5.222c6.408-9.765,10.61-20.374,12.661-31.187l-9.332-1.812 c2.006-10.153,1.861-20.51-0.182-30.475l9.285-1.927c-2.279-10.982-6.685-21.548-13.073-31l-7.88,5.307 c-5.57-8.268-12.841-15.584-21.703-21.399l5.221-7.957c-9.765-6.408-20.374-10.61-31.187-12.661l-1.812,9.332 c-10.153-2.006-20.51-1.861-30.474,0.182l-1.927-9.284c-11.012,2.26-21.548,6.686-31.001,13.073l0.041,0.069l3.497,5.185 l1.769,2.626c-8.268,5.569-15.604,12.872-21.399,21.702L3142.993,1013.713z M3181.113,1037.578 c12.272-17.825,36.566-23.42,55.362-12.696c21.598,12.324,27.817,40.243,13.853,60.473 c-12.282,17.792-36.545,23.379-55.338,12.692C3173.4,1085.769,3167.154,1057.852,3181.113,1037.578z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48C6C6"
    },
    d: "M2993.167,589.557c-10.27-59.349-101.839-85.784-99.888-47.029l-419.254,4.181 c-29.038,0.29-52.478,26.511-52.371,58.596l3.667,1102.669c0.111,33.24,24.179,60.318,53.776,60.45l428.017,1.911 c2.678,5.567,7.672,10.623,15.523,14.828c49.088,0.844,72.531-23.493,81.018-50.932c2.771-7.366,4.261-15.502,4.156-24.071 C3006.04,1695.812,2996.327,603.47,2993.167,589.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48C6C6"
    },
    d: "M2918.064,1785.356l-491.297-1.145c-30.658-0.072-55.57-27.882-55.655-62.083l-2.822-1133.999 c-0.082-32.981,24.213-59.871,54.276-60.092l481.733-3.547c30.302-0.223,55.193,26.427,55.583,59.556l13.42,1139.198 C2973.706,1757.605,2948.97,1785.428,2918.064,1785.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312A52"
    },
    d: "M2924.812,1777.08c-2.04,0.282-4.128,0.421-6.206,0.414l-491.149-1.695 c-26.344-0.091-47.977-24.473-48.055-54.326l-2.964-1132.754c-0.075-28.792,21.019-52.376,46.858-52.594l481.699-4.078 c0.753-0.006,1.515,0.007,2.264,0.038c12.125,0.512,23.475,5.988,31.981,15.403c8.694,9.623,13.56,22.404,13.719,36.008 l13.309,1140.353C2966.585,1750.877,2948.825,1773.761,2924.812,1777.08z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2936.092,589.299 2949.053,1725.683 2395.756,1724.647 2392.505,591.536  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFFAFA"
    },
    d: "M2486.835,1538.244c0,0-66.554-40.722-22.912-201.217s-84.754-243.49-14.184-331.768 c46.916-58.688,154.93,37.129,261.854-44.316c77.403-58.958,159.295-55.095,194.208,81.445 c51.472,201.296-60.786,287.999-29.458,389.258c39.278,126.958-64.373,202.414-178.934,144.924 C2624.383,1539.925,2532.659,1588.549,2486.835,1538.244z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48C6C6"
    },
    d: "M2642.496,851.122h-187.083c-7.563,0-13.693-6.13-13.693-13.693V692.973 c0-7.562,6.13-13.693,13.693-13.693h187.083c7.563,0,13.693,6.13,13.693,13.693v144.456 C2656.189,844.992,2650.059,851.122,2642.496,851.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDFF"
    },
    d: "M2646.26,832.462h-183.715V705.793c0-0.541,0.438-0.979,0.979-0.979 c0.54,0,0.979,0.439,0.979,0.979v124.711h181.758c0.54,0,0.979,0.438,0.979,0.979 C2647.238,832.023,2646.8,832.462,2646.26,832.462z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.829,
    y: 792.696,
    style: {
      fill: "#FDFDFF"
    },
    width: 20.281,
    height: 38.787
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2509.1,
    y: 783.858,
    style: {
      fill: "#FDFDFF"
    },
    width: 20.281,
    height: 47.625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2537.37,
    y: 765.938,
    style: {
      fill: "#FDFDFF"
    },
    width: 20.281,
    height: 65.545
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2565.64,
    y: 753.418,
    style: {
      fill: "#FDFDFF"
    },
    width: 20.281,
    height: 78.065
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2593.911,
    y: 726.414,
    style: {
      fill: "#FDFDFF"
    },
    width: 20.281,
    height: 105.069
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48C6C6"
    },
    d: "M2872.852,851.122h-187.084c-7.562,0-13.693-6.13-13.693-13.693V692.973 c0-7.562,6.13-13.693,13.693-13.693h187.084c7.562,0,13.693,6.13,13.693,13.693v144.456 C2886.545,844.992,2880.414,851.122,2872.852,851.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDFF"
    },
    d: "M2876.616,832.462H2692.9V712.666c0-0.54,0.438-0.979,0.979-0.979 c0.54,0,0.979,0.439,0.979,0.979v117.838h181.759c0.54,0,0.979,0.439,0.979,0.979 C2877.594,832.024,2877.156,832.462,2876.616,832.462z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDFDFF"
    },
    d: "M2693.878,831.483c30.777-2.68,35.063-126.427,80.724-70.946 c43.378,52.706,45.661-45.17,92.794-45.17v115.025C2867.396,830.392,2693.878,831.483,2693.878,831.483z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48C6C6"
    },
    d: "M2886.697,663.074h-444.766v-37.892h444.766V663.074z M2442.999,662.005h442.63V626.25h-442.63 V662.005z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2550.116,
    y: 637.763,
    style: {
      fill: "#48C6C6"
    },
    width: 73.828,
    height: 12.729
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2631.219,
    y: 637.763,
    style: {
      fill: "#48C6C6"
    },
    width: 38.187,
    height: 12.729
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2450.103,
    y: 637.763,
    style: {
      fill: "#48C6C6"
    },
    width: 90.194,
    height: 12.729
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48C6C6"
    },
    d: "M2886.697,1675.577h-444.766v-37.891h444.766V1675.577z M2442.999,1674.508h442.63v-35.755 h-442.63V1674.508z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2550.116,
    y: 1650.267,
    style: {
      fill: "#48C6C6"
    },
    width: 73.828,
    height: 12.729
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2631.219,
    y: 1650.267,
    style: {
      fill: "#48C6C6"
    },
    width: 38.187,
    height: 12.729
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2756.69,
    y: 1650.267,
    style: {
      fill: "#48C6C6"
    },
    width: 38.187,
    height: 12.729
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2450.103,
    y: 1650.267,
    style: {
      fill: "#48C6C6"
    },
    width: 90.194,
    height: 12.729
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2443.193,
    y: 875.284,
    style: {
      fill: "#CFFAFA"
    },
    width: 211.666,
    height: 12.002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.193,
    y: 919.472,
    style: {
      fill: "#CFFAFA"
    },
    width: 185.117,
    height: 12.002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.193,
    y: 897.106,
    style: {
      fill: "#CFFAFA"
    },
    width: 321.135,
    height: 12.002
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A3EEFA"
    },
    cx: 2791.224,
    cy: 478.326,
    r: 18.712
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3EEFA"
    },
    d: "M2724.992,419.677l-7.944-9.042c44.548-44.718,113.985-43.067,156.349,3.685l-8.376,8.643 C2827.04,381.195,2764.92,379.723,2724.992,419.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3EEFA"
    },
    d: "M2741.488,438.453l-7.944-9.042c34.954-34.826,89.196-33.546,122.46,2.857l-8.376,8.643 C2818.747,409.491,2771.821,408.39,2741.488,438.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3EEFA"
    },
    d: "M2757.456,456.628l-7.944-9.042c25.671-25.255,65.194-24.334,89.653,2.057l-8.376,8.643 C2810.716,436.875,2778.504,436.133,2757.456,456.628z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_robotic_arms"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1856.384,
    y: 537.215,
    style: {
      fill: "#241F3C"
    },
    width: 27.018,
    height: 124.518
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48C6C6"
    },
    d: "M1886.281,623.731h-31.668c-5.621,4.574-9.205,11.531-9.191,19.318l0.059,22.784l50.048-0.091 l-0.059-22.784C1895.455,635.205,1891.877,628.286,1886.281,623.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M1852.054,677.272L1852.054,677.272c-6.768-5.736-17.151-2.982-20.116,5.336l-24.233,67.977 c-0.655,1.837,0.123,3.884,1.836,4.833l0,0c1.823,1.01,4.109,0.453,5.25-1.278l39.691-60.222 C1858.003,688.577,1856.96,681.43,1852.054,677.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M1892.597,674.878L1892.597,674.878c7.395-4.901,17.383-0.947,19.35,7.661l16.083,70.353 c0.435,1.901-0.578,3.843-2.391,4.584l0,0c-1.929,0.789-4.134-0.032-5.063-1.885l-32.345-64.466 C1885.363,685.406,1887.237,678.43,1892.597,674.878z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1841.097,
    y: 665.734,
    style: {
      fill: "#241F3C"
    },
    width: 59.152,
    height: 7.138
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M1857.198,673.617c0,3.183-2.594,5.762-5.793,5.762c-3.2,0-5.793-2.58-5.793-5.762 c0-3.183,2.594-5.763,5.793-5.763C1854.605,667.855,1857.198,670.435,1857.198,673.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M1895.524,673.617c0,3.183-2.594,5.762-5.793,5.762c-3.2,0-5.793-2.58-5.793-5.762 c0-3.183,2.594-5.763,5.793-5.763C1892.93,667.855,1895.524,670.435,1895.524,673.617z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1767.467,
    y: 516.591,
    style: {
      fill: "#241F3C"
    },
    width: 102.068,
    height: 41.232
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48C6C6"
    },
    d: "M1783.151,582.339h-83.706c-24.926,0-45.132-20.206-45.132-45.132l0,0 c0-24.926,20.206-45.132,45.132-45.132h83.706V582.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48C6C6"
    },
    d: "M1864.735,582.339h-59.059v-90.264h59.059c24.926,0,45.132,20.206,45.132,45.132l0,0 C1909.867,562.133,1889.661,582.339,1864.735,582.339z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M1875.195,558.75c-12.16,5.07-26.2-0.645-31.297-12.74c-5.097-12.095,0.649-26.06,12.809-31.13 c12.16-5.07,26.2,0.645,31.297,12.74C1893.101,539.715,1887.355,553.68,1875.195,558.75z M1860.599,524.113 c-7.041,2.936-10.368,11.022-7.416,18.025c2.951,7.003,11.081,10.313,18.121,7.377c7.041-2.936,10.368-11.022,7.417-18.025 C1875.769,524.487,1867.64,521.177,1860.599,524.113z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#241F3C"
    },
    points: "1509.733,741.488 1437.8,630.74 1461.041,615.804 1532.974,726.553  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M1304.573,794.593L1304.573,794.593c-10.794-16.692-5.941-38.927,10.84-49.664l185.901-119.051 l39.09,60.446l-185.901,119.051C1337.721,816.112,1315.367,811.285,1304.573,794.593z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48C6C6"
    },
    d: "M1524.361,743.616l201.118-148.143c25.846-19.038,32.339-54.793,14.823-81.622h0 c-17.516-26.829-52.995-35.472-80.993-19.729l-217.445,122.48L1524.361,743.616z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M1710.303,579.539c-18.057,11.664-42.288,6.541-54.015-11.42 c-11.727-17.961-6.576-42.064,11.481-53.728c18.058-11.664,42.289-6.541,54.016,11.42 C1733.511,543.773,1728.361,567.875,1710.303,579.539z M1676.722,528.104c-10.456,6.754-13.438,20.709-6.648,31.11 c6.79,10.4,20.82,13.366,31.276,6.612c10.456-6.754,13.438-20.71,6.648-31.109 C1701.208,524.317,1687.178,521.35,1676.722,528.104z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CA6A6"
    },
    d: "M1398.687,1390.383L1398.687,1390.383c-60.177-23.827-89.54-91.666-65.586-151.522l108.73-271.691 c23.954-59.856,92.156-89.064,152.332-65.237l0,0c60.176,23.827,89.54,91.666,65.586,151.522l-108.731,271.691 C1527.065,1385.002,1458.864,1414.21,1398.687,1390.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41B3B3"
    },
    d: "M1630.759,1088.245L1630.759,1088.245c-48.933,42.207-123,36.966-165.433-11.707L1272.72,855.609 c-42.433-48.673-37.163-122.346,11.77-164.553v0c48.933-42.207,123-36.966,165.433,11.707l192.606,220.929 C1684.962,972.365,1679.692,1046.038,1630.759,1088.245z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M1316.354,727.608c-25.762,22.221-28.533,61.01-6.193,86.635 c22.34,25.625,61.335,28.388,87.098,6.167c25.766-22.225,28.537-61.013,6.197-86.638 C1381.115,708.147,1342.12,705.383,1316.354,727.608z M1380.997,801.758c-15.404,13.287-38.723,11.637-52.084-3.689 s-11.702-38.521,3.702-51.807c15.408-13.29,38.726-11.64,52.088,3.686S1396.405,788.467,1380.997,801.758z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M1576.174,946.882c-31.682-12.544-67.588,2.836-80.199,34.349 c-12.612,31.513,2.845,67.231,34.527,79.776c31.687,12.546,67.592-2.834,80.204-34.348 C1623.317,995.146,1607.861,959.428,1576.174,946.882z M1539.682,1038.068c-18.943-7.501-28.188-28.858-20.645-47.706 s29.015-28.043,47.958-20.542c18.948,7.503,28.193,28.86,20.65,47.708C1580.102,1036.375,1558.63,1045.571,1539.682,1038.068z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M1441.974,1240.377c-31.682-12.545-67.588,2.836-80.199,34.349 c-12.612,31.513,2.845,67.231,34.527,79.775c31.687,12.546,67.592-2.834,80.204-34.348 C1489.117,1288.641,1473.66,1252.923,1441.974,1240.377z M1405.481,1331.563c-18.943-7.501-28.188-28.858-20.645-47.706 c7.543-18.847,29.015-28.043,47.958-20.542c18.948,7.502,28.193,28.86,20.65,47.708S1424.429,1339.066,1405.481,1331.563z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M1534.787,1604.905h-213.112v-97.451c0-54.938,44.536-99.475,99.475-99.475h14.162 c54.938,0,99.475,44.536,99.475,99.475V1604.905z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48C6C6"
    },
    d: "M1397.668,1476.001c-20.222,17.442-22.396,47.888-4.861,68.001 c17.535,20.114,48.143,22.283,68.365,4.841c20.224-17.444,22.399-47.89,4.864-68.004 C1448.501,1460.726,1417.893,1458.557,1397.668,1476.001z M1448.408,1534.203c-12.091,10.429-30.394,9.134-40.882-2.896 c-10.488-12.03-9.185-30.235,2.906-40.664c12.094-10.432,30.397-9.136,40.885,2.893 C1461.804,1505.565,1460.502,1523.771,1448.408,1534.203z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312A52"
    },
    d: "M1634.438,1707.953h-406.723v-56.485c0-28.68,23.25-51.93,51.931-51.93h302.862 c28.68,0,51.93,23.25,51.93,51.93V1707.953z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160.903,
    y: 1674.752,
    style: {
      fill: "#241F3C"
    },
    width: 539.701,
    height: 108.415
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A7373"
    },
    d: "M3285.491,1794.23H238.161c-2.95,0-5.342-2.391-5.342-5.342s2.391-5.342,5.342-5.342h3047.33 c2.95,0,5.342,2.391,5.342,5.342S3288.441,1794.23,3285.491,1794.23z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Machine"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 377.543,
    y: 1068.789,
    style: {
      fill: "#E68D45"
    },
    width: 252.557,
    height: 221.697
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.669,
    y: 1068.789,
    style: {
      fill: "#FDB477"
    },
    width: 252.557,
    height: 221.697
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 558.932,
    y: 1068.789,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.277,
    height: 44.733
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 631.304,
    y: 1249.359,
    style: {
      fill: "#E68D45"
    },
    width: 26.262,
    height: 25.094
  }), /*#__PURE__*/React.createElement("rect", {
    x: 667.708,
    y: 1249.359,
    style: {
      fill: "#E68D45"
    },
    width: 26.262,
    height: 25.094
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.645,
    y: 1249.359,
    style: {
      fill: "#E68D45"
    },
    width: 26.262,
    height: 25.094
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48C6C6"
    },
    d: "M2763.419,1301.195H1034.011c-41.115,0-74.445,33.33-74.445,74.445v0 c0,41.115,33.33,74.445,74.445,74.445h1729.408V1301.195z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1938.364,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1905.485,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1970.781,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1971.242,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1937.902,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2004.121,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2036.999,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2003.66,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.417,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2036.538,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1905.024,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1773.971,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.878,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1741.093,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1773.51,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1872.607,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1740.632,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1708.214,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1872.145,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2464.42,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1839.728,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1839.267,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1806.849,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2233.809,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2299.566,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2365.784,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2332.906,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2332.444,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2300.027,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2365.323,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2431.542,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2398.201,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2463.958,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2398.663,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2431.08,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2266.687,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2168.052,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2135.635,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2102.756,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2135.174,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2168.513,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2102.295,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2267.149,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2234.27,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1707.753,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2201.392,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2200.931,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1806.389,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1149.28,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1181.699,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1083.523,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1116.402,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1182.159,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1115.942,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1148.821,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1247.916,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1214.578,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280.334,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1247.456,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1215.037,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050.645,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1675.336,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M962.44,1383.279l-13.108,1.387c0.626,5.91,1.878,11.762,3.721,17.396l12.527-4.098 C964.025,1393.209,962.968,1388.269,962.44,1383.279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M1004.562,1309.97l-5.413-12.018c-5.401,2.431-10.567,5.445-15.358,8.954l7.789,10.633 C995.631,1314.573,999.999,1312.025,1004.562,1309.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M980.432,1327.635l-9.812-8.802c-3.965,4.42-7.475,9.264-10.433,14.395l11.419,6.582 C974.108,1335.472,977.078,1331.375,980.432,1327.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M965.506,1353.541l-12.541-4.055c-1.825,5.641-3.057,11.499-3.663,17.412l13.112,1.344 C962.926,1363.249,963.966,1358.302,965.506,1353.541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M984.015,1444.538c4.804,3.496,9.983,6.492,15.393,8.906l5.372-12.036 c-4.572-2.041-8.949-4.574-13.011-7.528L984.015,1444.538z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1083.064,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050.186,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280.794,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M1033.769,1303.665l-0.046-13.18c-5.951,0.02-11.897,0.662-17.674,1.907l2.777,12.884 C1023.707,1304.224,1028.735,1303.683,1033.769,1303.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M1019.064,1446.054l-2.735,12.894c5.777,1.226,11.727,1.847,17.682,1.847h0.194v-13.181h-0.194 C1028.973,1447.613,1023.945,1447.088,1019.064,1446.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M960.328,1418.295c2.975,5.122,6.5,9.952,10.478,14.357l9.783-8.834 c-3.365-3.726-6.347-7.813-8.864-12.144L960.328,1418.295z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1543.822,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1576.24,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1510.483,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1510.943,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1576.7,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1543.361,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1674.875,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1642.458,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1641.997,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1609.118,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1609.579,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1445.186,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1379.43,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1378.969,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.551,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1313.673,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.091,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1477.605,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1411.848,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1478.065,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1313.213,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1412.308,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1444.726,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2562.594,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2759.865,
    y: 1290.485,
    style: {
      fill: "#241F3C"
    },
    width: 3.554,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2694.108,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2760.326,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 3.093,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2726.986,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2694.569,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2496.837,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2563.055,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2530.177,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2529.715,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2497.298,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2628.812,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2661.69,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2661.229,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2595.472,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2595.933,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2628.351,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2727.448,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M2763.419,1443.494H1034.011c-37.415,0-67.854-30.438-67.854-67.854s30.44-67.854,67.854-67.854 h1729.408v-13.181H1034.011c-44.683,0-81.036,36.353-81.036,81.035c0,44.682,36.353,81.035,81.036,81.035h1729.408V1443.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#241F3C"
    },
    d: "M2746.979,1443.494H1017.572c-37.415,0-67.855-30.438-67.855-67.854s30.44-67.854,67.855-67.854 h1729.408v-13.181H1017.572c-44.683,0-81.036,36.353-81.036,81.035c0,44.682,36.353,81.035,81.036,81.035h1729.408V1443.494z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312A52"
    },
    d: "M1012.952,1344.953c-16.127,13.985-17.862,38.396-3.877,54.523 c13.985,16.127,38.396,17.866,54.523,3.881c16.13-13.987,17.864-38.398,3.879-54.525 C1053.492,1332.705,1029.082,1330.967,1012.952,1344.953z M1053.418,1391.619c-9.643,8.362-24.24,7.323-32.604-2.322 c-8.364-9.645-7.326-24.243,2.317-32.604c9.645-8.364,24.243-7.326,32.607,2.32 C1064.102,1368.658,1063.064,1383.255,1053.418,1391.619z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312A52"
    },
    d: "M1416.243,1344.953c-16.127,13.985-17.862,38.396-3.877,54.523 c13.985,16.127,38.396,17.866,54.523,3.881c16.13-13.987,17.864-38.398,3.879-54.525 C1456.784,1332.705,1432.373,1330.967,1416.243,1344.953z M1456.71,1391.619c-9.643,8.362-24.24,7.323-32.604-2.322 c-8.364-9.645-7.326-24.243,2.317-32.604c9.645-8.364,24.243-7.326,32.607,2.32 C1467.394,1368.658,1466.355,1383.255,1456.71,1391.619z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312A52"
    },
    d: "M1819.535,1344.953c-16.127,13.985-17.862,38.396-3.877,54.523 c13.985,16.127,38.396,17.866,54.523,3.881c16.13-13.987,17.864-38.398,3.879-54.525 C1860.075,1332.705,1835.664,1330.967,1819.535,1344.953z M1860.001,1391.619c-9.643,8.362-24.24,7.323-32.604-2.322 c-8.364-9.645-7.325-24.243,2.317-32.604c9.645-8.364,24.243-7.326,32.607,2.32 C1870.685,1368.658,1869.647,1383.255,1860.001,1391.619z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312A52"
    },
    d: "M2222.826,1344.953c-16.127,13.985-17.862,38.396-3.877,54.523 c13.985,16.127,38.396,17.866,54.523,3.881c16.129-13.987,17.864-38.398,3.879-54.525 C2263.367,1332.705,2238.956,1330.967,2222.826,1344.953z M2263.293,1391.619c-9.643,8.362-24.24,7.323-32.604-2.322 c-8.364-9.645-7.325-24.243,2.317-32.604c9.645-8.364,24.243-7.326,32.607,2.32 C2273.977,1368.658,2272.938,1383.255,2263.293,1391.619z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312A52"
    },
    d: "M2626.118,1344.953c-16.127,13.985-17.862,38.396-3.877,54.523 c13.985,16.127,38.396,17.866,54.523,3.881c16.129-13.987,17.864-38.398,3.879-54.525 C2666.658,1332.705,2642.247,1330.967,2626.118,1344.953z M2666.584,1391.619c-9.643,8.362-24.24,7.323-32.604-2.322 c-8.364-9.645-7.325-24.243,2.317-32.604c9.645-8.364,24.243-7.326,32.607,2.32 C2677.268,1368.658,2676.229,1383.255,2666.584,1391.619z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 208.702,
    y: 1301.195,
    style: {
      fill: "#48C6C6"
    },
    width: 659.546,
    height: 148.89
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569.249,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.637,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.394,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.613,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.735,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.273,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.856,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.151,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.37,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.03,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 568.787,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.492,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.909,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.516,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.881,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.464,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.702,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 15.323,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.002,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.342,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.702,
    y: 1290.485,
    style: {
      fill: "#241F3C"
    },
    width: 14.861,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.978,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.099,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.221,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.759,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 667.423,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864.693,
    y: 1290.485,
    style: {
      fill: "#241F3C"
    },
    width: 3.554,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 798.937,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 865.155,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 3.093,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 831.815,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 799.398,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.666,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 667.884,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.006,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.544,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.127,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 733.641,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 766.519,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 766.058,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700.301,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700.762,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 733.18,
    y: 1290.486,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832.276,
    y: 1447.613,
    style: {
      fill: "#241F3C"
    },
    width: 16.439,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.702,
    y: 1443.494,
    style: {
      fill: "#241F3C"
    },
    width: 659.546,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.702,
    y: 1294.605,
    style: {
      fill: "#241F3C"
    },
    width: 659.546,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.702,
    y: 1443.494,
    style: {
      fill: "#241F3C"
    },
    width: 643.106,
    height: 13.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.702,
    y: 1294.605,
    style: {
      fill: "#241F3C"
    },
    width: 643.106,
    height: 13.181
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312A52"
    },
    d: "M327.655,1344.953c-16.127,13.985-17.862,38.396-3.877,54.523 c13.985,16.127,38.396,17.866,54.523,3.881c16.129-13.987,17.864-38.398,3.879-54.525 C368.195,1332.705,343.785,1330.967,327.655,1344.953z M368.122,1391.619c-9.643,8.362-24.24,7.323-32.604-2.322 c-8.364-9.645-7.326-24.243,2.317-32.604c9.645-8.364,24.243-7.326,32.607,2.32 C378.805,1368.658,377.767,1383.255,368.122,1391.619z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312A52"
    },
    d: "M730.947,1344.953c-16.127,13.985-17.862,38.396-3.877,54.523 c13.985,16.127,38.396,17.866,54.523,3.881c16.129-13.987,17.864-38.398,3.879-54.525 C771.487,1332.705,747.076,1330.967,730.947,1344.953z M771.413,1391.619c-9.643,8.362-24.24,7.323-32.604-2.322 c-8.364-9.645-7.326-24.243,2.317-32.604c9.645-8.364,24.243-7.326,32.607,2.32 C782.097,1368.658,781.058,1383.255,771.413,1391.619z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 208.702,
    y: 1445.345,
    style: {
      fill: "#312A52"
    },
    width: 659.589,
    height: 32.371
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#312A52"
    },
    points: "474.92,1290.274 474.92,1477.936 408.366,1477.936 453.712,1290.486  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312A52"
    },
    d: "M2763.462,1445.345H869.261c-8.939,0-16.186,7.247-16.186,16.186 c0,8.939,7.247,16.186,16.186,16.186h1894.201V1445.345z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.293,
    y: 911.676,
    style: {
      fill: "#3D3466"
    },
    width: 361.555,
    height: 878.175
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.293,
    y: 911.676,
    style: {
      fill: "#241F3C"
    },
    width: 288.454,
    height: 878.175
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 518.017,
    y: 665.521,
    style: {
      fill: "#338C8C"
    },
    width: 604.873,
    height: 45.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -289.3029 633.936)",
    style: {
      fill: "#338C8C"
    },
    cx: 620.577,
    cy: 666.187,
    rx: 25.367,
    ry: 25.367
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48C6C6"
    },
    d: "M1172.342,1789.851V727.72c0-16.899-13.699-30.598-30.598-30.598H506.316 c-16.899,0-30.598,13.699-30.598,30.598v1062.131H1172.342z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 524.17,
    y: 1530.508,
    style: {
      fill: "#312A52"
    },
    width: 23.937,
    height: 189.652
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.641,
    y: 1530.508,
    style: {
      fill: "#312A52"
    },
    width: 23.937,
    height: 189.652
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.113,
    y: 1530.508,
    style: {
      fill: "#312A52"
    },
    width: 23.937,
    height: 189.652
  }), /*#__PURE__*/React.createElement("rect", {
    x: 663.584,
    y: 1530.508,
    style: {
      fill: "#312A52"
    },
    width: 23.937,
    height: 189.652
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710.055,
    y: 1530.508,
    style: {
      fill: "#312A52"
    },
    width: 23.937,
    height: 189.652
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.526,
    y: 1530.508,
    style: {
      fill: "#312A52"
    },
    width: 23.937,
    height: 189.652
  }), /*#__PURE__*/React.createElement("rect", {
    x: 802.997,
    y: 1530.508,
    style: {
      fill: "#312A52"
    },
    width: 23.937,
    height: 189.652
  })), /*#__PURE__*/React.createElement("rect", {
    x: 519.658,
    y: 747.228,
    style: {
      fill: "#CFFAFA"
    },
    width: 607.308,
    height: 646.533
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#48C6C6"
    },
    cx: 717.204,
    cy: 1145.4,
    r: 75.119
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82EDED"
    },
    d: "M665.688,1101.484l25.505,24.096c-4.407,5.536-7.077,12.505-7.2,20.093h-35.036 C649.096,1128.768,655.381,1113.33,665.688,1101.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82EDED"
    },
    d: "M671.454,1095.594c11.755-10.627,27.227-17.218,44.238-17.58l-0.478,35.061 c-6.796,0.404-13.049,2.842-18.132,6.731L671.454,1095.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82EDED"
    },
    d: "M763.885,1096.459l-25.134,24.5c-4.292-3.666-9.532-6.253-15.298-7.357l0.478-35.284 C739.327,1079.826,753.225,1086.441,763.885,1096.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82EDED"
    },
    d: "M785.444,1145.673h-35.028c-0.123-6.936-2.356-13.346-6.104-18.626l25.233-24.599 C779.364,1114.162,785.304,1129.222,785.444,1145.673z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#268080"
    },
    points: "696.139,1091.738 723.784,1139.519 710.807,1144.997  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#268080"
    },
    d: "M727.738,1138.438c2.385,5.651-0.262,12.165-5.913,14.551 c-5.651,2.385-12.165-0.262-14.551-5.913c-2.385-5.651,0.262-12.165,5.913-14.551 C718.838,1130.14,725.352,1132.787,727.738,1138.438z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#48C6C6"
    },
    cx: 928.529,
    cy: 1145.4,
    r: 75.119
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82EDED"
    },
    d: "M877.012,1101.484l25.505,24.096c-4.407,5.536-7.077,12.505-7.2,20.093h-35.036 C860.421,1128.768,866.706,1113.33,877.012,1101.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82EDED"
    },
    d: "M882.779,1095.594c11.755-10.627,27.227-17.218,44.238-17.58l-0.478,35.061 c-6.796,0.404-13.049,2.842-18.132,6.731L882.779,1095.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82EDED"
    },
    d: "M975.21,1096.459l-25.134,24.5c-4.292-3.666-9.532-6.253-15.298-7.357l0.478-35.284 C950.652,1079.826,964.55,1086.441,975.21,1096.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82EDED"
    },
    d: "M996.769,1145.673H961.74c-0.123-6.936-2.356-13.346-6.104-18.626l25.233-24.599 C990.689,1114.162,996.629,1129.222,996.769,1145.673z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#268080"
    },
    points: "982.211,1128.26 931.218,1149.405 927.488,1135.822  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#268080"
    },
    d: "M931.772,1153.467c-5.915,1.624-12.026-1.854-13.65-7.769 c-1.624-5.915,1.854-12.026,7.769-13.65c5.915-1.624,12.026,1.854,13.65,7.769S937.686,1151.843,931.772,1153.467z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 596.673,
    y: 831.453,
    style: {
      fill: "#48C6C6"
    },
    width: 447.589,
    height: 168.267
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 736.142,
    y: 951.164,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736.142,
    y: 923.112,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736.142,
    y: 895.06,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736.142,
    y: 867.008,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 778.018,
    y: 951.164,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 778.018,
    y: 923.112,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 778.018,
    y: 895.06,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 904.854,
    y: 951.164,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 904.854,
    y: 923.112,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 904.854,
    y: 895.06,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 820.558,
    y: 951.164,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 820.558,
    y: 923.112,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 820.558,
    y: 895.06,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 820.558,
    y: 867.008,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 862.433,
    y: 951.164,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651.727,
    y: 951.164,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 862.433,
    y: 923.112,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 694.267,
    y: 951.164,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.267,
    y: 923.112,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 946.184,
    y: 951.164,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 946.184,
    y: 923.112,
    style: {
      fill: "#82EDED"
    },
    width: 36.164,
    height: 23.75
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 655.454,
    y: 1285.143,
    style: {
      fill: "#48C6C6"
    },
    width: 40.806,
    height: 40.806
  }), /*#__PURE__*/React.createElement("rect", {
    x: 717.04,
    y: 1285.143,
    style: {
      fill: "#48C6C6"
    },
    width: 40.806,
    height: 40.806
  }), /*#__PURE__*/React.createElement("rect", {
    x: 778.626,
    y: 1285.143,
    style: {
      fill: "#48C6C6"
    },
    width: 40.806,
    height: 40.806
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840.212,
    y: 1285.143,
    style: {
      fill: "#48C6C6"
    },
    width: 40.806,
    height: 40.806
  }), /*#__PURE__*/React.createElement("rect", {
    x: 901.798,
    y: 1285.143,
    style: {
      fill: "#48C6C6"
    },
    width: 40.806,
    height: 40.806
  }), /*#__PURE__*/React.createElement("rect", {
    x: 963.384,
    y: 1285.143,
    style: {
      fill: "#48C6C6"
    },
    width: 40.806,
    height: 40.806
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1518.792,
    y: 1068.789,
    style: {
      fill: "#E68D45"
    },
    width: 252.557,
    height: 221.697
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1594.917,
    y: 1068.789,
    style: {
      fill: "#FDB477"
    },
    width: 252.557,
    height: 221.697
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1700.181,
    y: 1068.789,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.277,
    height: 44.733
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1772.552,
    y: 1249.359,
    style: {
      fill: "#E68D45"
    },
    width: 26.262,
    height: 25.094
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1808.957,
    y: 1249.359,
    style: {
      fill: "#E68D45"
    },
    width: 26.262,
    height: 25.094
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1735.894,
    y: 1249.359,
    style: {
      fill: "#E68D45"
    },
    width: 26.261,
    height: 25.094
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1974.855,
    y: 1068.789,
    style: {
      fill: "#E68D45"
    },
    width: 252.557,
    height: 221.697
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2050.98,
    y: 1068.789,
    style: {
      fill: "#FDB477"
    },
    width: 252.557,
    height: 221.697
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2156.244,
    y: 1068.789,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.277,
    height: 44.733
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2228.615,
    y: 1249.359,
    style: {
      fill: "#E68D45"
    },
    width: 26.261,
    height: 25.094
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2265.02,
    y: 1249.359,
    style: {
      fill: "#E68D45"
    },
    width: 26.262,
    height: 25.094
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2191.957,
    y: 1249.359,
    style: {
      fill: "#E68D45"
    },
    width: 26.262,
    height: 25.094
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A3EEFA"
    },
    cx: 622.16,
    cy: 596.405,
    r: 22.831
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3EEFA"
    },
    d: "M541.348,524.846l-9.692-11.032c54.354-54.562,139.077-52.547,190.766,4.496l-10.219,10.545 C665.859,477.894,590.065,476.097,541.348,524.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3EEFA"
    },
    d: "M561.474,547.755l-9.692-11.032c42.648-42.492,108.831-40.93,149.418,3.486l-10.22,10.545 C655.741,512.418,598.485,511.075,561.474,547.755z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3EEFA"
    },
    d: "M580.958,569.932l-9.692-11.032c31.322-30.815,79.545-29.691,109.389,2.51l-10.22,10.545 C645.942,545.831,606.639,544.925,580.958,569.932z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -5.0203 1812.3228)",
    style: {
      fill: "#48C6AA"
    },
    cx: 2185.157,
    cy: 912.221,
    rx: 74.192,
    ry: 74.192
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2167.922,951.196c-2.863,0-5.609-1.137-7.633-3.162l-23.428-23.428 c-4.216-4.216-4.216-11.051,0-15.267c4.216-4.215,11.052-4.215,15.267,0l15.794,15.795l46.941-46.941 c4.216-4.216,11.051-4.216,15.267,0c4.216,4.216,4.216,11.051,0,15.267l-54.574,54.574 C2173.531,950.058,2170.785,951.196,2167.922,951.196z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 1020.4095 2651.176)",
    style: {
      fill: "#48C6AA"
    },
    cx: 2185.157,
    cy: 680.917,
    rx: 74.192,
    ry: 74.192
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2167.922,719.891c-2.863,0-5.609-1.138-7.633-3.162l-23.428-23.428 c-4.216-4.216-4.216-11.051,0-15.267c4.216-4.215,11.052-4.215,15.267,0l15.794,15.795l46.941-46.941 c4.216-4.216,11.051-4.216,15.267,0c4.216,4.216,4.216,11.051,0,15.267l-54.574,54.574 C2173.531,718.753,2170.785,719.891,2167.922,719.891z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2430.918,
    y: 1068.789,
    style: {
      fill: "#E68D45"
    },
    width: 252.557,
    height: 221.697
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2507.043,
    y: 1068.789,
    style: {
      fill: "#FDB477"
    },
    width: 252.557,
    height: 221.697
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2612.307,
    y: 1068.789,
    style: {
      fill: "#FFFFFF"
    },
    width: 27.277,
    height: 44.733
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2684.678,
    y: 1249.359,
    style: {
      fill: "#E68D45"
    },
    width: 26.261,
    height: 25.094
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2721.083,
    y: 1249.359,
    style: {
      fill: "#E68D45"
    },
    width: 26.261,
    height: 25.094
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2648.02,
    y: 1249.359,
    style: {
      fill: "#E68D45"
    },
    width: 26.262,
    height: 25.094
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineryLoan);
export default __webpack_public_path__ + "static/media/machinery-loan.ad1c65ceb76a53772d615b61a25bf78e.svg";
export { ForwardRef as ReactComponent };